import React from 'react';
import ReactDOM from 'react-dom/client';
import { Watch, InfinitySpin, Puff } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

const Loader = () => {
    const isVisible = useSelector((state) => state.loader.isVisible);
    console.log(isVisible);

	return (
        <div>
        { 
            isVisible && (
                <div className='loader'>
                    <div className='loader-inner'>
                        <Watch
                            height="100"
                            width="100"
                            radius="48"
                            color="#000000"
                            ariaLabel="watch-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={true}
                            />
                    </div>
                     
                </div>
        )}
        </div>
	);
};

export default Loader;